module.exports = __webpack_public_path__ + "img/main-01-08.fedfd3e9.png";